import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const usePartnerMetrics = (partnerId?: string) => {
  return useQuery({
    queryKey: ["partner-metrics", partnerId],
    queryFn: async () => {
      if (!partnerId) throw new Error("Partner ID is required");

      console.log("🔍 Fetching metrics for partner:", partnerId);

      // Use the database function to get partner metrics with proper relationship handling
      const { data, error } = await supabase.rpc('get_partner_metrics', {
        partner_id_param: partnerId
      });

      if (error) {
        console.error("❌ Error fetching partner metrics:", error);
        throw error;
      }

      const result = data?.[0] || { contacts_count: 0, proposals_count: 0 };
      
      console.log(`📊 Partner ${partnerId} metrics:`, {
        contactsCount: result.contacts_count,
        proposalsCount: result.proposals_count
      });

      return {
        contactsCount: Number(result.contacts_count) || 0,
        proposalsCount: Number(result.proposals_count) || 0,
      };
    },
    enabled: !!partnerId,
  });
};